var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSpeedBoost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFD2",
    d: "M0 10C0 4.477 4.477 0 10 0h40c5.523 0 10 4.477 10 10v40c0 5.523-4.477 10-10 10H10C4.477 60 0 55.523 0 50V10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "m35.532 28.321-3.92 3.92a.967.967 0 0 1-.706.294.989.989 0 0 1-.707-.294 1.006 1.006 0 0 1 0-1.413l3.92-3.92a1.006 1.006 0 0 1 1.413 0c.4.387.4 1.027 0 1.413Zm-4.613-7.626c-6 0-10.88 4.88-10.88 10.88 0 .136.003.273.008.407a.396.396 0 0 0 .398.38h4.474a2.658 2.658 0 0 1 2.659 2.862c-.022.266.168.524.435.524h.226a2.666 2.666 0 0 1 2.583 3.323c-.059.23.1.477.337.477a2.66 2.66 0 0 1 2.58 2.018c.06.247.305.425.547.346 4.357-1.417 7.513-5.51 7.513-10.337 0-6-4.88-10.88-10.88-10.88ZM28.122 18.786h5.611a1 1 0 0 0 0-2h-5.61a1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#091540",
    fillRule: "evenodd",
    d: "M29.233 38.413a1 1 0 0 0-1-1h-5.721a1 1 0 0 0 0 2h5.721a1 1 0 0 0 1-1ZM31.152 41.214h-5.721a1 1 0 0 0 0 2h5.721a1 1 0 0 0 0-2ZM25.924 35.026a1 1 0 0 0-1-1H19.2a1 1 0 0 0 0 2h5.723a1 1 0 0 0 1-1Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpeedBoost);
export default __webpack_public_path__ + "static/media/logo-speed-boost.cd7881271a67900b5609a097bf062d32.svg";
export { ForwardRef as ReactComponent };